import React, {ReactElement, useLayoutEffect, useRef, useState} from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { Button, Spin } from 'antd';
import { injectIntl } from 'react-intl';
import { useSvgDrawing } from 'react-hooks-svgdrawing';

import { useDispatch, useSelector } from 'react-redux';
import GrayContainer from '../../components/grayContainer/grayContainer';
import { savePacienteRGPD } from '../../../../state/actions/creators/pacientes.actioncreator';
import { ROUTE_PACIENTES_GDPR } from '../../../../routes.constants';
import Page from '../../../shared/components/layout/Page.layout';
import SignatureCanvas from 'react-signature-canvas';
import {
  Text,
  Flex,
} from '../../../shared/components';

interface signGDPRProps {
  intl: any
}

function SignGDPR({ intl }:signGDPRProps) {
  const dispatch = useDispatch();
  const { pacienteId }: any = useParams();
  const { pacienteSelected } = useSelector((state: any) => state.pacientesWorkspace);
  const sigCanvasRef = useRef(null);
  const [firmando, setFirmando] = useState<any>();
  const filePath = generatePath(ROUTE_PACIENTES_GDPR, { pacienteId });
  const history = useHistory();
  const rgpdSaga = useSelector((state: any) => state.sagas.PACIENTES_SAVE_PACIENTE_RGPD);
  const saving = firmando || (rgpdSaga && rgpdSaga.running);
  const [size, setSize] = useState([0, window.innerHeight - 306]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight - 306]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  function saveSign() {
    // @ts-ignore
    let emptyCanvas = sigCanvasRef && sigCanvasRef.current ? sigCanvasRef.current.isEmpty() : true;
    if (emptyCanvas) {
      window.alert(intl.formatMessage({ id: 'pacientes.signGDPR.cant_save' }));
      return;
    }
    setFirmando(true);
    // eslint-disable-next-line no-use-before-define
    svgToPng(sigCanvasRef, 8, null)
      .then((firma) => {
        dispatch(savePacienteRGPD({ pacienteId, firma }));
        setFirmando(false);
      });

  }

  function clearSign() {
    // @ts-ignore
    sigCanvasRef.current.clear();
  }

  const signGDPR: ReactElement = (
    <>
      <div
        className="canvas"
        style={{
          width: '100%',
          height: size[1],
        }}
      >
        <div className="drawContainer">
          <div className="drawer">
          <SignatureCanvas ref={sigCanvasRef} penColor='black' dotSize={2.2} throttle={12} velocityFilterWeight={0.1}
                           canvasProps={{width: size[0], height: size[1],}} />
          </div>
        </div>
      </div>
      <div className="footerSign">
        <div onClick={clearSign}><p className="clear">{intl.formatMessage({ id: 'pacientes.signGDPR.delete_sign' })}</p></div>
        <div className="footerButtons">
          <Button onClick={() => history.push(filePath)}>{intl.formatMessage({ id: 'pacientes.signGDPR.cancel' })}</Button>
          <Button type="primary" style={{ marginLeft: '8px' }} disabled={false} onClick={saveSign}>
            {intl.formatMessage({ id: 'pacientes.signGDPR.sign' })}
          </Button>
        </div>
      </div>
    </>
  );
  return (
    <Page
      titulo={pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${pacienteId})`}
      navigationItems={[
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.home" />,
          link: '',
        },
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.pacientes" />,
          link: '/pacientes/buscar',
        },
        {
          node: <Text upperCase={false} lowerCase={false} translationId={null}>{pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${pacienteId})`}</Text>,
          link: `/pacientes/file/${pacienteId}`,
        },
      ]}
    >
      <div className="patient patient-gdpr-sign">
        {saving ? <Flex justifyContent="center" alignItems="center"><Spin size="large" /></Flex> : signGDPR}
      </div>
    </Page>
  );
}

export default injectIntl(SignGDPR);

const svgToPng = (sigCanvasRef: any, margin: number, fill: any) =>
  // convert an svg text to png using the browser
  new Promise(((resolve, reject) => {
    try {
      // can use the domUrl function from the browser
      const domUrl = window.URL || window.webkitURL || window;
      if (!domUrl) {
        throw new Error('(browser doesnt support this)');
      }
      const canvasElement: HTMLElement = document.getElementsByClassName('canvas')[0] as HTMLElement;
      const canvasWidth = canvasElement ? canvasElement.offsetWidth: 200;
      const canvasHeight = canvasElement ? canvasElement.offsetHeight: 200;
      // figure out the height and width from svg text
      const height = canvasHeight;
      const width = canvasWidth;
      margin = margin || 0;

      let canvas = sigCanvasRef.current.getTrimmedCanvas();
      let dataURL = canvas.toDataURL('image/svg');
      let url = dataURL;
      // it needs a namespace
      if (!dataURL.match(/xmlns=\"/mi)) {
        //url  = dataURL.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ');
      }

      // create a canvas element to pass through
      canvas.width = height*2 + margin * 2;
      canvas.height = width*2 + margin * 2;
      const ctx = canvas.getContext('2d');

      // make a blob from the svg
      const svg = new Blob([dataURL], {
        type: 'image/svg+xml;charset=utf-8',
      });

      // create a dom object for that image
      //const url = domUrl.createObjectURL(svg);

      // create a new image to hold it the converted type
      const img = new Image();

      // when the image is loaded we can get it as base64 url
      img.onload = function () {
        // draw it to the canvas
        // @ts-ignore
        ctx.drawImage(this, margin, margin);

        // if it needs some styling, we need a new canvas
        if (fill) {
          const styled = document.createElement('canvas');
          styled.width = canvas.width;
          styled.height = canvas.height;
          const styledCtx = styled.getContext('2d');
          // @ts-ignore
          styledCtx.save();
          // @ts-ignore
          styledCtx.fillStyle = fill;
          // @ts-ignore
          styledCtx.fillRect(0, 0, canvas.width, canvas.height);
          // @ts-ignore
          styledCtx.strokeRect(0, 0, canvas.width, canvas.height);
          // @ts-ignore
          styledCtx.restore();
          // @ts-ignore
          styledCtx.drawImage(canvas, 0, 0);
          canvas = styled;
        }
        // we don't need the original any more
        domUrl.revokeObjectURL(url);
        // now we can resolve the promise, passing the base64 url
        canvas.toBlob((blob:any) => {
          resolve(blob);
        });
      };

      // load the image
      img.src = url;
    } catch (err) {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject(`failed to convert svg to png ${err}`);
    }
  }));
